module.exports = __webpack_public_path__ + "media/images/office_chair_sidebar-d2bdb3702d483815181f35278096b73f.png";